import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { usePaymentPage } from './PaymentPage/usePaymentPage';
import BookingSummaryCard from './PaymentPage/BookingSummaryCard';
import AmountCard from './PaymentPage/AmountCard';
import InitiatePaymentStep from './PaymentPage/InitiatePaymentStep';
import CardPaymentForm from './PaymentPage/CardPaymentForm';

export default function PaymentPage() {
  const { bookingId } = useParams();
  const navigate = useNavigate();
  const {
    booking, processing, paymentInitiated, paymentData, cardDetails, errors,
    handleCardInputChange, fillTestCard, handleInitiatePayment, handleProcessPayment,
  } = usePaymentPage(bookingId);

  if (!booking) {
    return (
      <div className="mobile-container min-h-screen flex items-center justify-center">
        <p className="text-muted-foreground">Loading...</p>
      </div>
    );
  }

  const finalTotal = booking.final_total ?? 0;

  return (
    <div className="mobile-container min-h-screen pb-6" data-testid="payment-page">
      <div className="bg-primary text-primary-foreground p-6">
        <div className="flex items-center gap-4">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => navigate(`/booking/${bookingId}`)}
            data-testid="back-button"
            className="text-primary-foreground hover:bg-white/20"
          >
            <ArrowLeft className="w-5 h-5" />
          </Button>
          <h1 className="text-2xl font-black font-heading uppercase">Payment</h1>
        </div>
      </div>

      <div className="p-6 space-y-6">
        <BookingSummaryCard booking={booking} />
        <AmountCard booking={booking} />

        {!paymentInitiated ? (
          <InitiatePaymentStep
            finalTotal={finalTotal}
            processing={processing}
            onInitiate={handleInitiatePayment}
          />
        ) : (
          <CardPaymentForm
            finalTotal={finalTotal}
            paymentData={paymentData}
            cardDetails={cardDetails}
            errors={errors}
            processing={processing}
            onFillTestCard={fillTestCard}
            onCardChange={handleCardInputChange}
            onSubmit={handleProcessPayment}
          />
        )}
      </div>
    </div>
  );
}
